import React from "react";
import { SpinnerContainer, SpinnerWrapper } from "./styles";
import { LoadingSpinnerProps } from "./types";

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 50,
  color = "var(--color-white)",
}) => {
  return (
    <SpinnerContainer aria-label="Loading application">
      <SpinnerWrapper size={size} color={color} />
    </SpinnerContainer>
  );
};
